import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { SERVICE_ICONS, IMAGES } from "../data/content";
import { useContent } from "../context/ContentContext";

export default function Services() {
  const { content } = useContent();
  return (
    <div data-testid="services-page">
      <section className="bg-charcoal text-white py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal><Eyebrow>Our Services</Eyebrow></Reveal>
          <Reveal delay={1}>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-700 mt-5 max-w-3xl leading-[1.08] tracking-tight text-balance">
              Everything your property needs, done right.
            </h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="text-white/75 text-lg mt-6 max-w-2xl leading-relaxed">
              From weekly maintenance to drainage projects, we handle the full scope —
              so your yard looks its best and functions the way it should.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-20">
          {content.services.map((s, gi) => {
            const Icon = SERVICE_ICONS[gi] || SERVICE_ICONS[0];
            return (
            <div key={s.group}>
              <Reveal>
                <div className="flex items-center gap-4 mb-8">
                  <span className="grid place-items-center w-14 h-14 rounded-sm bg-emerald text-white shrink-0">
                    <Icon className="w-7 h-7" strokeWidth={1.75} />
                  </span>
                  <div>
                    <h2 className="font-display text-2xl sm:text-3xl font-600 text-charcoal">{s.group}</h2>
                    <p className="text-olive">{s.blurb}</p>
                  </div>
                </div>
              </Reveal>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {s.items.map((it, i) => (
                  <Reveal key={it.name} delay={i}>
                    <div className="h-full bg-[#F8F9FA] p-7 border border-border rounded-sm hover:bg-white hover:shadow-md hover:-translate-y-1 transition-all duration-300" data-testid={`service-item-${gi}-${i}`}>
                      <div className="flex items-center gap-2.5 mb-2">
                        <CheckCircle2 className="w-5 h-5 text-emerald shrink-0" />
                        <h3 className="font-600 text-charcoal text-lg">{it.name}</h3>
                      </div>
                      <p className="text-olive text-[15px] leading-relaxed pl-7">{it.desc}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
            );
          })}
        </div>
      </section>

      <section className="relative py-24">
        <img src={IMAGES.stone} alt="Stone hardscaping" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/75" />
        <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center text-white">
          <Reveal>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-600 leading-tight text-balance">
              Not sure what you need? Let's figure it out together.
            </h2>
          </Reveal>
          <Reveal delay={1}>
            <p className="text-white/80 text-lg mt-5 max-w-2xl mx-auto">
              Send us your property details and a few photos — we'll recommend the right plan and a fair price.
            </p>
          </Reveal>
          <Reveal delay={2}>
            <Link to="/quote" className="inline-flex items-center gap-2 bg-gold text-charcoal px-9 py-4 rounded-sm font-700 mt-9 hover:bg-gold-dark transition-colors" data-testid="services-quote-btn">
              Request a Free Quote <ArrowRight className="w-5 h-5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
